import { VinoDataOffer } from "../../types/vino-data-types";
import { isFlagEnabled } from "../../utils/is-flag-enabled";

export const shouldShowDiscountBadge = ({
  displayFlags,
  packPrice,
  sku,
}: VinoDataOffer): boolean => {
  const { packRRP } = sku || { packRRP: undefined };

  return (
    !isFlagEnabled(displayFlags, "HIDE_DISCOUNT") &&
    packRRP &&
    packRRP > packPrice
  );
};
